import * as React from "react";
import { SVGProps } from "react";
export const TabletIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <mask
            id="mask0_20606_9035"
            style={{
                maskType: "alpha",
            }}
            maskUnits="userSpaceOnUse"
            x={0}
            y={0}
            width={20}
            height={20}
        >
            <rect width={20} height={20} fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_20606_9035)">
            <path
                d="M7.125 9.25C6.94444 9.25 6.79514 9.19097 6.67708 9.07292C6.55903 8.95486 6.5 8.80556 6.5 8.625C6.5 8.44444 6.55903 8.29514 6.67708 8.17708C6.79514 8.05903 6.94444 8 7.125 8H12.875C13.0556 8 13.2049 8.05903 13.3229 8.17708C13.441 8.29514 13.5 8.44444 13.5 8.625C13.5 8.80556 13.441 8.95486 13.3229 9.07292C13.2049 9.19097 13.0556 9.25 12.875 9.25H7.125ZM8.125 12C7.94444 12 7.79514 11.941 7.67708 11.8229C7.55903 11.7049 7.5 11.5556 7.5 11.375C7.5 11.1944 7.55903 11.0451 7.67708 10.9271C7.79514 10.809 7.94444 10.75 8.125 10.75H11.875C12.0556 10.75 12.2049 10.809 12.3229 10.9271C12.441 11.0451 12.5 11.1944 12.5 11.375C12.5 11.5556 12.441 11.7049 12.3229 11.8229C12.2049 11.941 12.0556 12 11.875 12H8.125ZM2.5 16C2.0875 16 1.73438 15.853 1.44063 15.5591C1.14688 15.2652 1 14.9119 1 14.4992V5.4941C1 5.08137 1.14688 4.72917 1.44063 4.4375C1.73438 4.14583 2.0875 4 2.5 4H17.5C17.9125 4 18.2656 4.14696 18.5594 4.44087C18.8531 4.73479 19 5.08811 19 5.50083V14.5059C19 14.9186 18.8531 15.2708 18.5594 15.5625C18.2656 15.8542 17.9125 16 17.5 16H2.5ZM3.5 5.5H2.5V14.5H3.5V5.5ZM5 14.5H15V5.5H5V14.5ZM16.5 5.5V14.5H17.5V5.5H16.5Z"
                fill="currentColor"
            />
        </g>
    </svg>
);
TabletIcon.displayName = "TabletIcon";
